var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Schedule",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.28,
    height: 19.28,
    viewBox: "0 0 19.28 19.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M0,0H19.28V19.28H0Z",
    fill: "none",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    d: "M6.106,16.315A7.331,7.331,0,0,1,3.919,6.771a.387.387,0,0,1-.059-.059L3.431,6.18A1.933,1.933,0,0,1,3.78,3.413,2.051,2.051,0,0,1,6.6,3.751l.146.181a7.337,7.337,0,0,1,7.158,0l.146-.182a2.051,2.051,0,0,1,2.821-.338,1.933,1.933,0,0,1,.348,2.767l-.429.532a.387.387,0,0,1-.059.059,7.331,7.331,0,0,1-2.187,9.544L16,17.765a.386.386,0,0,1-.545.545L13.91,16.768a.389.389,0,0,1-.03-.034,7.337,7.337,0,0,1-7.107,0,.389.389,0,0,1-.03.034L5.2,18.311a.386.386,0,0,1-.545-.545ZM16.3,6.089l.317-.393a1.162,1.162,0,0,0-.214-1.668,1.28,1.28,0,0,0-1.755.207l-.091.113A7.368,7.368,0,0,1,16.3,6.089Zm-11.955,0A7.368,7.368,0,0,1,6.091,4.347L6,4.235a1.28,1.28,0,0,0-1.755-.207A1.162,1.162,0,0,0,4.031,5.7l.317.393Zm5.978,10.792a6.555,6.555,0,1,0-6.555-6.555A6.555,6.555,0,0,0,10.326,16.881Z",
    transform: "translate(-0.686 -0.686)",
    fill: "#326483"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    "data-name": "path",
    d: "M9.665,9.51a.386.386,0,0,0-.559.531l2.342,2.466a.386.386,0,0,0,.553.006l3.827-3.856a.386.386,0,0,0-.547-.543l-3.548,3.574Z",
    transform: "translate(-2.059 -1.831)",
    fill: "#0c9aa3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.fa979d33f1aca85232d867f1ac8c8787.svg";
export { ForwardRef as ReactComponent };